import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0207 from "../lesson-07/lesson";
import lesson0214 from "../lesson-14/lesson";
import lesson0222 from "../lesson-22/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "54e926e2-76f6-4fa7-96e0-c33b230471bc",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0207),
    lesson: lesson0207,
  },
  {
    id: "2c4a7065-ae90-4359-b66f-3824f7e7c768",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0214),
    lesson: lesson0214,
  },
  {
    id: "27a35fb3-c06e-4560-a56d-2a924861852f",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0222),
    lesson: lesson0222,
  },
];

export default lessonLinks;
